import React, { useRef } from "react";
import './App.css';
import { Route, Routes, useLocation } from 'react-router-dom';

import Home from './pages/Home';
import LatestProducts from "./pages/LatestProducts";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";

import Header from './components/Header';
import Footer from './components/Footer';
import SingleProductCard from "./components/SingleProductCard";
import Login from "./components/Login";

import AdminLayout from "./adminPages/AdminLayout";
import AddProduct from "./adminPages/AddProduct";
import EditProduct from "./adminPages/EditProduct";
import DeleteProduct from "./adminPages/DeleteProduct";
import ManageQuotes from "./adminPages/ManageQuotes";
import ManageProductRequests from "./adminPages/ManageProductRequests";

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  const productRef = useRef(null);

  const scrollToProducts = () => {
    productRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <>
      {/* ❌ HIDE HEADER IN ADMIN */}
      {!isAdminRoute && <Header onProductClick={scrollToProducts} />}

      <Routes>
        <Route path='/' element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/product/:id" element={<SingleProductCard />} />
        <Route path="/latest-products" element={<LatestProducts />} />

        {/* ADMIN LOGIN (NO HEADER/FOOTER) */}
        <Route path="/admin/login" element={<Login />} />

        {/* ADMIN PANEL */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="products/add" element={<AddProduct />} />
          <Route path="products/edit" element={<EditProduct />} />
          <Route path="products/delete" element={<DeleteProduct />} />
          <Route path="quotes" element={<ManageQuotes />} />
          <Route path="requests" element={<ManageProductRequests />} />
        </Route>
      </Routes>

      {/* ❌ HIDE FOOTER IN ADMIN */}
      {!isAdminRoute && <Footer />}
    </>
  );
}

export default App;
